(() => {
  const normalizePath = (href) => {
    if (!href) return '';
    try { return new URL(href, window.location.origin).pathname.replace(/\/$/, '') || '/'; }
    catch (error) { return href.replace(/\/$/, '') || '/'; }
  };

  const routeMap = new Map([
    ['/pages/faqs', '/pages/faq'],
    ['/pages/shipping-delivery', '/pages/shipping-policy'],
    ['/pages/returns-exchanges', '/pages/return-refund-policy'],
    ['/collections/sale', '/collections/all-products'],
    ['/pages/sale', '/collections/all-products'],
    ['/collections/gift-cards', '/pages/gift-guide'],
    ['/blogs/journal', '/blogs/news']
  ]);

  const textRoutes = [
    { test: /faq|faqs/i, href: '/pages/faq' },
    { test: /track order|order tracking|where is my order/i, href: '/pages/order-tracking' },
    { test: /shipping|delivery/i, href: '/pages/shipping-policy' },
    { test: /returns|refund|exchange|item issue/i, href: '/pages/return-refund-policy' },
    { test: /quality promise|guarantee|our promise/i, href: '/pages/quality-promise' },
    { test: /product care|care guide|materials/i, href: '/pages/product-care' },
    { test: /contact|customer care|support team|care team/i, href: '/pages/contact' },
    { test: /support center|help center|support/i, href: '/pages/support' },
    { test: /privacy/i, href: '/pages/privacy-policy' },
    { test: /terms/i, href: '/pages/terms-of-service' },
    { test: /journal|articles/i, href: '/blogs/news' },
    { test: /gift guide/i, href: '/pages/gift-guide' },
    { test: /wishlist/i, href: '/pages/wishlist' },
    { test: /bundles|sets/i, href: '/pages/bundles' }
  ];

  const dead = (href) => !href || ['#', '', 'javascript:void(0)', 'javascript:;'].includes(href.trim());
  const label = (el) => (el.textContent || el.getAttribute('aria-label') || el.getAttribute('title') || '').replace(/\s+/g, ' ').trim();

  const patchLinks = (root = document) => {
    root.querySelectorAll('a').forEach((link) => {
      const href = link.getAttribute('href') || '';
      const path = normalizePath(href);
      if (routeMap.has(path)) {
        link.setAttribute('href', routeMap.get(path));
        return;
      }
      if (dead(href)) {
        const text = label(link);
        const match = textRoutes.find((rule) => rule.test.test(text));
        if (match) link.setAttribute('href', match.href);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => patchLinks(document));
  document.addEventListener('shopify:section:load', (event) => patchLinks(event.target));
})();